var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('TopToolbar'),_vm._v(" "),(!_vm.firstLoad && _vm.$route.path !== '/')?_c('BottomNav'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }